<div style="margin: 5px 5px 5px 5px">
  <mat-form-field>
    <mat-label>
      Please select a service
    </mat-label>

    <mat-select [(value)]="selectedServicePath" (selectionChange)="setService()">
      @for (endPoint of serviceRegister.end_points; track endPoint) {
        <mat-option [value]="endPoint.path">{{endPoint.title}}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  @if (selectedService) {
    <div>
      <form>
        <p>Selected service: {{selectedService.title}}</p>
        @for (parameter of selectedService.parameters; track parameter) {
          @if (['add_to_path', 'string', 'number', 'list'].includes(parameter.param_type)) {
            <mat-form-field>
              <mat-label>{{parameter.title}}</mat-label>
              <input matInput [formControl]="parameter.formControl">
            </mat-form-field>
          }
          @if (parameter.param_type === 'object') {
            <mat-form-field>
              <mat-label>{{parameter.title}}</mat-label>
              <textarea matInput [formControl]="parameter.formControl"></textarea>
            </mat-form-field>
          }
        }
        <button type="submit" mat-button (click)="executeService()">Execute service</button>
      </form>
    </div>

  }
  @if (executing) {
    <div>
      <p>Executing service...</p>
    </div>
  } @else if (executeTime) {
    <div>
      <p>Execution time: {{executeTime}} ms</p>
    </div>
  }
  @if (executeResult) {
    <div>
      <p>Last result:</p>
      <pre style="background: #b3b4b4">{{executeResult | json}}</pre>
    </div>
  }
  @if (errorMessage) {
    <div>
      <p>Error occurred:</p>
      <pre style="color: darkred">{{errorMessage}}</pre>
    </div>
  }

</div>
